import React from 'react'
import styles from './RemainingGuesses.module.css'

const RemainingGuesses = props => {
  return (
    <div className={styles.RemainingGuesses}>
      <div className={styles.text}>Remaining Guesses:</div>
      <div className={styles.number}>{props.remainingGuesses}</div>
    </div>
  )
}

export default RemainingGuesses